<template>
  <div>
    <div v-for="(agent, agentIndex) in agentList" :key="agentIndex">
      <h4>{{ agentType }} {{ agentIndex + 1 }} Details</h4>

      <div class="row d-flex align-items-center" style="margin-bottom: 30px">
        <div class="col-md-4">
          <label for="inlineFormInput">Date of Birth</label>
          <div class="input-group">
            <input
              type="text"
              id="dobInput"
              class="form-control"
              v-model="agent.dateOfBirth"
              :placeholder="`DD-MM-YYYY`"
              @input="
                validateDateOfBirth($event.target.value, agent, validation)
              "
            />
          </div>

          <small v-if="validation.dateOfBirth" class="text-danger">{{
            validation.dateOfBirth
          }}</small>
        </div>

        <div class="col-md-4">
          <label for="inlineFormInput">BVN</label>
          <div class="input-group">
            <input
              type="text"
              id="bvnInput"
              class="form-control"
              v-model="agent.bvn"
              :placeholder="`Enter BVN`"
              :maxLength="11"
              @input="handleBvnInput($event.target.value, agent, validation)"
            />
          </div>

          <small v-if="validation.bvn" class="text-danger">{{
            validation.bvn
          }}</small>
        </div>

        <button
          @click="handleBvnValidation(agent, agentList, agentIndex)"
          class="btn btn-info col-md-2 d-flex validate-btn justify-content-center align-items-center"
          style="font-size: 10px; height: 40px !important; margin-top: 10px"
          :disabled="!isBvnValid(agent)"
        >
          <span v-if="isValidating" class="spin"></span>
          Validate
        </button>
      </div>

      <div class="row" style="row-gap: 15px">
        <div class="col-md-4" v-for="(field, index) in fields" :key="index">
          <label for="inlineFormInput">{{ field.label }}</label>
          <div class="input-group" style="display: flex; align-items: center">
            <input
              :type="field.type"
              v-model="agent[field.key]"
              class="form-control"
              :maxlength="field.key === 'nin' ? 11 : undefined"
              :placeholder="`Enter ${field.label}`"
              @input="handleInput(agent, field)"
            />
            <span
              v-if="isValidatingNin && field.key === 'nin'"
              class="spin"
            ></span>
          </div>

          <small v-if="validation.nin" class="text-danger">{{
            validation.nin
          }}</small>
        </div>
      </div>

      <span
        class="view-more"
        style="color: red; font-size: 12px"
        @click="removeAgent(agentList, agentIndex)"
        v-if="agentList.length > 1"
      >
        Remove
      </span>
    </div>

    <span class="view-more" @click="addNewAgent(agentList)">
      Add new {{ agentType.slice(0, -1) }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    isValidating: { type: false },
    isValidatingNin: { type: false },
    agentList: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    agentType: {
      type: String,
      required: true,
    },
    validateDateOfBirth: {
      type: Function,
      required: true,
    },
    handleBvnValidation: {
      type: Function,
      required: true,
    },
    addNewAgent: {
      type: Function,
      required: true,
    },
    removeAgent: {
      type: Function,
      required: true,
    },
    handleBvnInput: {
      type: Function,
      required: true,
    },
    handleSelectChange: {
      type: Function,
      // required: true,
    },
    getOptions: {
      type: Function,
      // required: true,
    },
    handleInput: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      validation: {
        bvn: "",
        dateOfBirth: "",
        nin: "",
        errors: {},
      },
    };
  },
  methods: {
    isBvnValid(agent) {
      return agent.dateOfBirth && agent.bvn;
    },
  },
};
</script>

<style scoped>
label {
  color: #9a9a9a;
  font-size: 10px;
}

input,
select {
  background-color: #fafafa;
  font-size: 10px;
}

input::placeholder,
select::placeholder {
  color: #b6b6b4 !important;
}

input:disabled,
select:disabled {
  background-color: #f5f5f5;
  color: #71797e;
}

.validate-btn {
  gap: 8px;
}

.spin {
  border: 2px solid rgba(101, 179, 199, 0.2);
  border-left-color: #65b3c7;
  width: 15px;
  height: 15px;
}
</style>
